import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../Styles/Login.css';
import logo from '../Images/SAVI AI full.png';
import { FiHash, FiUser } from 'react-icons/fi';

const VendorLogin = () => {
  const [vendorCode, setVendorCode] = useState('');
  const [vendorName, setVendorName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!vendorCode.trim() || !vendorName.trim()) {
      setError('Please enter both Vendor Code and Vendor Name.');
      return;
    }
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('userType', 'vendor');
    localStorage.setItem('vendorCode', vendorCode.trim());
    localStorage.setItem('vendorName', vendorName.trim());
    navigate('/invoice-hub', { replace: true });
  };

  return (
    <div className="login-main-container">
      <header className="login-header">
        <div className="login-logo">
          <img src={logo} alt="SAVI AI" className="login-logo-image" />
        </div>
      </header>
      <div className="login-form-bg">
        <div className="login-form-container">
          <h1 className="login-form-title">
            Sign in to <span className="login-title-highlight">Savi</span>
          </h1>

          <form onSubmit={handleSubmit}>
            <div className="login-input-group login-password-field">
              <FiHash className="login-input-icon" />
              <input
                type="text"
                value={vendorCode}
                onChange={(e) => { setVendorCode(e.target.value); setError(''); }}
                placeholder="Enter your Vendor Code"
                className="login-input-field"
                autoFocus
              />
            </div>

            <div className="login-input-group login-password-field" style={{ marginTop: 12 }}>
              <FiUser className="login-input-icon" />
              <input
                type="text"
                value={vendorName}
                onChange={(e) => { setVendorName(e.target.value); setError(''); }}
                placeholder="Enter your Vendor Name"
                className="login-input-field"
              />
            </div>

            {error && <p className="login-error-message">{error}</p>}

            <div style={{ marginTop: 16 }}>
              <button
                type="submit"
                className="login-button"
                disabled={!vendorCode.trim() || !vendorName.trim()}
                style={{ width: '100%' }}
              >
                Sign In as Vendor
              </button>
            </div>
          </form>

          <div className="login-signup-prompt">
            Not a vendor?{' '}
            <Link to="/signin-type" className="login-signup-link">Go back</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorLogin;
